module.exports = __webpack_public_path__ + "img/empty.83595a61.png";